import { differenceInMonths } from "date-fns";

export const isFinishingSoon = (finishOn: string): boolean => {
  const finishOnDate = new Date(finishOn);
  const todaysDate = new Date(Date.now());

  return differenceInMonths(finishOnDate, todaysDate) < 1;
};
